import React, { useState } from 'react';
import './styles.css';
import FullInventory from '../../../../components/Icons/FullInventory';
import PartialInventory from '../../../../components/Icons/PartialInventory';
import FullInventoryForm from '../FullInventoryForm';
import PartialInventoryForm from '../PartialInventoryForm';

export const CreateInventoryModal = ({isOpen, onClose, posId, onInventoryCreated}) =>
{
  const [step, setStep] = useState('select-type'); // 'select-type', 'full-form', 'partial-form'
  const [inventoryType, setInventoryType] = useState(null);

  if (!isOpen) return null;

  const handleSelectType = (type) =>
  {
    setInventoryType(type);
    setStep(type === 'FULL' ? 'full-form' : 'partial-form');
  };

  const handleBack = () =>
  {
    setStep('select-type');
    setInventoryType(null);
  };

  const handleClose = () =>
  {
    setStep('select-type');
    setInventoryType(null);
    onClose();
  };

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        {step === 'select-type' && (
          <>
            <div className="modal-header">
              <h2 className="modal-title">Create Inventory</h2>
              <button className="modal-close" onClick={handleClose}>×</button>
            </div>
            <div className="modal-body">
              <p className="modal-subtitle">Select the type of inventory you want to create</p>

              <div className="inventory-type-options">
                <button
                  className="inventory-type-option"
                  onClick={() => handleSelectType('FULL')}
                >
                  <div className="option-icon">
                    <FullInventory/>
                  </div>
                  <div className="option-content">
                    <h3 className="option-title">Create Full Inventory</h3>
                    <p className="option-description">Count all items in your warehouse</p>
                  </div>
                  <div className="option-arrow">›</div>
                </button>

                <button
                  className="inventory-type-option"
                  onClick={() => handleSelectType('PARTIAL')}
                >
                  <div className="option-icon">
                    <PartialInventory/>
                  </div>
                  <div className="option-content">
                    <h3 className="option-title">Create Partial Inventory</h3>
                    <p className="option-description">Count specific items with filters</p>
                  </div>
                  <div className="option-arrow">›</div>
                </button>
              </div>
            </div>
          </>
        )}

        {step === 'full-form' && (
          <FullInventoryForm
            posId={posId}
            onBack={handleBack}
            onClose={handleClose}
            onSuccess={onInventoryCreated}
          />
        )}

        {step === 'partial-form' && (
          <PartialInventoryForm
            posId={posId}
            onBack={handleBack}
            onClose={handleClose}
            onSuccess={onInventoryCreated}
          />
        )}
      </div>
    </div>
  );
};
